import { Outlet } from 'react-router';

import { AuthorisationProvider, RequireAuthorisation } from 'providers/AuthorisationProvider';
import { RequireAuth } from 'routes/RequireAuth';
import { Unauthorized } from 'App/Unauthorized/Unauthorized';
import { UserProfileProvider } from 'providers/UserProfileProvider';
import { UserBlocked } from 'App/UserBlocked';

export const ProtectedRoute = () => (
  <RequireAuth>
    <UserProfileProvider>
      <AuthorisationProvider>
        <RequireAuthorisation suspended={<UserBlocked />} unauthorized={<Unauthorized />}>
          <Outlet />
        </RequireAuthorisation>
      </AuthorisationProvider>
    </UserProfileProvider>
  </RequireAuth>
);
